<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'inline',
      validator: value => ['inline', 'stacked'].includes(value),
    },
    isSuspended: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isInline() {
      return this.layout === 'inline';
    },
    titleClass() {
      return [
        this.isInline ? 'text-lg' : 'text-base',
        this.isSuspended
          ? 'text-slate-400'
          : 'text-slate-700 dark:text-slate-100',
      ];
    },
    subtitleClass() {
      return this.isInline
        ? 'font-medium flex items-center lowercase'
        : 'mt-0.5';
    },
  },
  methods: {
    onSelect() {
      if (this.isSuspended) return;
      this.$emit('select');
    },
  },
};
</script>

<template>
  <button
    type="button"
    class="flex items-center justify-between w-full px-3 py-2 rounded-lg expanded clear link"
    :class="
      isSuspended
        ? 'cursor-default'
        : 'cursor-pointer hover:underline hover:bg-slate-25 dark:hover:bg-slate-900'
    "
    :disabled="isSuspended"
    @click="onSelect"
  >
    <span
      class="w-full text-left rtl:text-right flex"
      :class="
        isInline ? 'flex-row items-center justify-between gap-4' : 'flex-col'
      "
    >
      <span
        class="flex items-center gap-2 font-medium leading-5 hover:underline-offset-4"
        :class="titleClass"
      >
        {{ title }}
        <span
          v-if="isSuspended"
          class="inline-flex items-center px-1.5 py-0.5 text-xs font-medium normal-case rounded text-slate-500 bg-slate-75 dark:text-slate-300 dark:bg-slate-800"
        >
          {{ $t('SIDEBAR_ITEMS.SUSPENDED_ACCOUNT') }}
        </span>
      </span>
      <span
        v-if="subtitle"
        class="text-xs text-slate-500 dark:text-slate-500 hover:underline-offset-4"
        :class="subtitleClass"
      >
        {{ subtitle }}
      </span>
    </span>
    <slot name="trailing" />
  </button>
</template>
